<template>
  <v-dialog width="500" v-model="dialog">
    <v-card>
      <v-btn absolute style="right: 0" class="mt-1" icon @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-title>{{ $t("edit") }}</v-card-title>
      <v-card-text>
        <v-list dense>
          <v-list-item class="pl-0">
            <v-list-item-title
              >{{ $t("nContract") }}: {{ contractItem.code }}</v-list-item-title
            >
          </v-list-item>
          <v-list-item class="pl-0">
            <v-list-item-title
              >{{ $t("contractNumber") }}:
              {{ contractItem.numb }}</v-list-item-title
            >
          </v-list-item>

          <v-list-item class="pl-0">
            <v-list-item-title v-if="contractItem.state"
              >{{ $t("state") }}:
              {{
                $t(`contractStatus.${contractItem.state}`)
              }}</v-list-item-title
            >
          </v-list-item>
        </v-list>
        <custom-select
          v-model="selectedStatus"
          :label="$t('state')"
          class="user_input no-margin"
          :items="orderItemStatus"
          item-text="text"
          item-value="value"
        ></custom-select>
        <div class="text-right mt-4">
          <v-btn @click="submit" color="primary" :loading="loading">{{
            $t("save")
          }}</v-btn>
        </div>
      </v-card-text>
      <warning-dialog
        yes-text="yes"
        description="wantToContinue"
        v-model="warningDialog"
        @apply="changeState"
        ref="warningDialogRef"
      ></warning-dialog>
    </v-card>
  </v-dialog>
</template>

<script>
import { contractItemStatus } from "@/utils/constants.js";
import WarningDialog from "@/components/ui/prompt/warning-dialog.vue";

export default {
  name: "OzlContractItemChangeStatusDialog",
  components: { WarningDialog },
  data() {
    return {
      warningDialog: false,
      dialog: false,
      loading: false,
      contractItem: {},
      selectedStatus: null,
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.contractItem = {};
        this.loading = false;
        this.selectedStatus = null;
      }
    },
  },
  methods: {
    async changeState() {
      this.loading = true;
      try {
        await this.$http.post("backend/contract-item-change-state", {
          state: this.selectedStatus,
          id: this.contractItem.id,
        });
        this.$emit("changed");
        this.setSuccess({ text: this.$t("successfullySaved") });
        this.dialog = false;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },

    async submit() {
      this.$refs.warningDialogRef.open();
    },
    /**
     * @typedef orderItem {Object}
     * @property numb {number}
     * @property itemNumb {number}
     * @property state {string}
     * @property id {number}
     * @param data {orderItem}
     */
    open(data) {
      this.dialog = true;
      this.contractItem = data;
      this.selectedStatus = data.state;
    },
    close() {
      this.dialog = false;
    },
  },
  computed: {
    orderItemStatus() {
      return Object.keys(contractItemStatus).map((item) => {
        return {
          text: this.$t(`contractStatus.${item}`),
          value: item,
        };
      });
    },
  },
};
</script>
